var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view pa24",staticStyle:{"margin-top":"16px"}},[_c('div',{attrs:{"id":"container"}})])}]

export { render, staticRenderFns }